/**
 * SDK document
 * https://developers.ecpay.com.tw/?p=35559
 */

export const Language = {
  zhTW: 'zh-TW',
  enUS: 'en-US',
} as const

export const ServerEnv = {
  Prod: 'Prod',
  Stage: 'Stage',
} as const

export type LanguageType = typeof Language[keyof typeof Language]
export type ServerEnvType = typeof ServerEnv[keyof typeof ServerEnv]

export interface ECPayPaymentInfo {
  PayToken: string
}

export interface ECPay {
  /**
   * Initialize ECPay
   * @param serverType - Stage : 測試環境, Prod : 正式環境
   * @param isLoading - 是否顯示等待畫面，0: 否, 1: 是，如無傳入該參數，預設為1
   * @param callback - callback function，如初始化失敗將回傳 errMsg 錯誤訊息
   */
  initialize: (serverType: ServerEnvType, isLoading: number, callback: (errMsg?: string) => void) => void

  createPayment: (token: string, language: LanguageType, callback: (errMsg?: string) => void, version: string) => void

  /**
   * 取得綁定信用卡畫面
   * @param token - 信用卡綁定Token
   * @param language - 語言
   * @param callback - callback function，如綁定失敗將回傳 errMsg 錯誤訊息
   */
  addBindingCard: (token: string, language: LanguageType, callback: (errMsg?: string) => void) => void

  /**
   * 取得綁定信用卡代碼
   * @param callback - callback function，如綁定失敗將回傳 errMsg 錯誤訊息
   */
  getBindCardPayToken: (callback: (bindCardPayToken: string, errMsg?: string) => void) => void

  /**
   * 取得語言
   */
  getLanguage: () => LanguageType

  /**
   * 取得信用卡的PayToken
   * @param callback - callback function，如綁定失敗將回傳 errMsg 錯誤訊息
   */
  getPayToken: (callback: (paymentInfo: ECPayPaymentInfo, errMsg: string) => void) => void
}

declare global {
  interface Window {
    ECPay?: ECPay
  }
}
